import { Link } from "react-router-dom";
import { MessageSquare, ClipboardList, Target, BadgeCheck, ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SPEEDY_METHOD } from "../data/content";

const ICONS = { MessageSquare, ClipboardList, Target, BadgeCheck };

export default function SpeedyMethod() {
  return (
    <section className="mx-auto max-w-7xl px-5 md:px-10 py-24" data-testid="home-speedy-method">
      <Reveal>
        <Overline className="text-gold">The Speedy Method</Overline>
        <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl tracking-tight">
          FOUR STEPS. <span className="gold-text">ZERO GUESSWORK.</span>
        </h2>
        <p className="mt-5 max-w-xl text-zinc-300">
          The same proven method behind Speedy Line Marking — refined for premium court resurfacing.
        </p>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {SPEEDY_METHOD.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.n} delay={i * 0.08}>
              <Link to={`/method/${s.slug}`} data-testid={`method-step-${i}`}
                    className="group relative flex h-full flex-col rounded-lg border border-white/10 bg-obsidian-800 p-7 hover:border-gold/40 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-gold/10 text-gold group-hover:bg-gold group-hover:text-obsidian transition-colors"><Icon size={22} /></span>
                  <span className="font-heading font-black text-4xl text-zinc-800 group-hover:text-gold/40 transition-colors">{s.n}</span>
                </div>
                <h3 className="mt-6 font-heading font-bold text-xl group-hover:text-neon transition-colors">{s.title}</h3>
                <p className="mt-2 text-sm text-zinc-300 flex-1">{s.text}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-gold">
                  Read step {s.n} <ArrowUpRight size={13} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </Link>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/method" data-testid="method-learn-more" className="group inline-flex items-center gap-2 rounded-sm bg-gold px-7 py-4 font-bold text-obsidian hover:bg-gold-hover transition-colors shadow-gold">
            Explore The Method <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
          <Link to="/quote" data-testid="method-quote" className="inline-flex items-center gap-2 rounded-sm border border-white/25 px-7 py-4 font-bold hover:border-neon hover:text-neon transition-colors">
            Get a Free Quote <ArrowRight size={18} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
